import {Provider} from './provider';

declare const process: any;

export class LoggerProvider extends Provider {

    log(message: any) {
        return this.submit(process.env.LOGGER_URL, message);
    }
}
